var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7193 8.55572C10.6227 10.2108 8.64353 14.8735 10.2986 18.97C11.9538 23.0666 16.6164 25.0458 20.713 23.3907C21.2744 23.1638 21.8081 22.8511 22.3028 22.4832C19.442 21.6331 17.2753 19.7153 16.1318 17.272C14.8479 14.5287 14.8861 11.1938 16.5656 8.09504C15.9277 8.17193 15.3016 8.32046 14.7193 8.55572ZM8.44428 19.7193C6.37538 14.5986 8.84936 8.77025 13.9701 6.70135C15.1171 6.2379 16.3385 6.04945 17.4854 6.03194C18.1147 6.02233 18.6011 6.39476 18.827 6.86127C19.0467 7.3149 19.0398 7.8855 18.7321 8.36091C16.9385 11.1322 16.8516 14.0918 17.9432 16.4242C19.035 18.757 21.3442 20.5464 24.5315 20.8983L26.4704 21.1124L25.1646 22.5616C24.2072 23.6242 22.9484 24.6446 21.4622 25.245C16.3415 27.3139 10.5132 24.84 8.44428 19.7193Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;